import { render, staticRenderFns } from "./CartTakeOutTable.vue?vue&type=template&id=c4efc35e&scoped=true&"
import script from "./CartTakeOutTable.vue?vue&type=script&lang=js&"
export * from "./CartTakeOutTable.vue?vue&type=script&lang=js&"
import style0 from "./CartTakeOutTable.vue?vue&type=style&index=0&id=c4efc35e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4efc35e",
  null
  
)

export default component.exports